export function getMatchingContactsById(
  selectedContacts: any,
  contacts: any
): any {
  return selectedContacts
    .map((selectedContact: any) =>
      contacts.find((contact: any) => contact._id === selectedContact.value)
    )
    .filter((contact: any) => contact !== undefined); // Filter out unmatched contacts
}
